<style lang="scss" scoped></style>

<template>
  <td>
    <div>{{ minutes }} Minuten</div>
  </td>
</template>

<script lang="babel">
import moment from 'moment';

export default {
    props: ['content', 'label'],
    data() {
      return {
        minutes: 0,
        intervalId: null
      };
    },
    methods: {
      setMinutes() {
        this.minutes = parseInt(moment.duration(moment().diff(moment(this.content))).asMinutes());
      }
    },
    created() {
      this.setMinutes();
      this.intervalId = setInterval(this.setMinutes, 60000);
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
    }
};
</script>
